import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { adminApi } from '../../lib/admin-api/index.js';
import { getRuntimeConfig } from '../../lib/runtime-config.js';
import { BrandedMark, normalizeBranding } from '../../shared/branding/branding.jsx';

function ResetPasswordPage() {
  const { otp } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const branding = normalizeBranding(getRuntimeConfig().branding);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setFieldErrors({});

    if (newPassword !== confirmPassword) {
      setFieldErrors({ confirmPassword: t('auth.passwordsDoNotMatch') });
      return;
    }

    setIsSubmitting(true);
    try {
      await adminApi.resetPassword(otp, newPassword);
      navigate('/login', { replace: true, state: { passwordReset: true } });
    } catch (err) {
      setError(err.message || t('auth.resetFailed'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="main-wrapper" className="auth-customizer-none">
      <div className="position-relative overflow-hidden radial-gradient min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100">
            <div className="col-md-8 col-lg-6 col-xxl-3 auth-card">
              <div className="card mb-0 position-relative">
                <div className="card-body">
                  <div className="text-nowrap logo-img d-flex align-items-center justify-content-center mb-4 w-100">
                    <BrandedMark branding={branding} imageClassName="crm-brand-logo-auth" imageHeight={52} />
                  </div>

                  <h5 className="mb-1">{t('auth.resetPasswordTitle')}</h5>
                  <p className="mb-4 text-muted">{t('auth.resetPasswordSubtitle')}</p>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="newPassword" className="form-label">{t('auth.newPasswordLabel')}</label>
                      <input
                        type="password"
                        className={`form-control ${fieldErrors.newPassword ? 'is-invalid' : ''}`}
                        id="newPassword"
                        value={newPassword}
                        onChange={(event) => setNewPassword(event.target.value)}
                        autoComplete="new-password"
                        required
                      />
                      {fieldErrors.newPassword && (
                        <div className="invalid-feedback">{fieldErrors.newPassword}</div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label htmlFor="confirmPassword" className="form-label">{t('auth.confirmPasswordLabel')}</label>
                      <input
                        type="password"
                        className={`form-control ${fieldErrors.confirmPassword ? 'is-invalid' : ''}`}
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(event) => setConfirmPassword(event.target.value)}
                        autoComplete="new-password"
                        required
                      />
                      {fieldErrors.confirmPassword && (
                        <div className="invalid-feedback">{fieldErrors.confirmPassword}</div>
                      )}
                    </div>

                    {error && <div className="alert alert-danger py-2">{error}</div>}

                    <button type="submit" className="btn btn-primary w-100 py-8 mb-4" disabled={isSubmitting}>
                      {isSubmitting ? t('auth.saving') : t('auth.setNewPassword')}
                    </button>
                  </form>

                  <div className="d-flex align-items-center justify-content-center">
                    <Link to="/login" className="text-primary fw-medium">
                      {t('auth.backToSignIn')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
